<div class="detail-box">
    <ng-container class="detail-item" *ngIf="swaitchDetails && swaitchDetails.length > 0; else no_switch">
        <table aria-label="quote-table" class="table">
            <thead class="bg-light">
                <tr>
                    <th scope="col">Data effetto</th>
                    <th scope="col">Fondo provenienza</th>
                    <th scope="col">Fondo destinazione</th>
                    <th scope="col">Percentuale</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let swaitchDetail of swaitchDetails">
                    <tr>
                        <td>{{ swaitchDetail.effectDate | date }}</td>
                        <td>{{ swaitchDetail.originFund }}</td>
                        <td>{{ swaitchDetail.destinationFund }}</td>
                        <td>{{ swaitchDetail.percentage }}</td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </ng-container>
    <ng-template #no_switch>
        <h6>Non risultano switch.</h6>
    </ng-template>
</div>
